export class DayScheduleTab {
	constructor() {
	}
} 
